
import PhotoSwipeLightbox from "./photoswipe-lightbox.esm.min.js";

const lightbox = new PhotoSwipeLightbox({
  // may select multiple "galleries"
  gallery: ".photoswipe",

  // Elements within gallery (slides)
  children: "a",

  // setup PhotoSwipe Core dynamic import
  pswpModule: () => import("./photoswipe.esm.min.js"),

  bgOpacity: 1,
});

class NeighboringProduct extends HTMLElement {
  constructor() {
    super();
    this.handleCardClick = this.handleCardClick.bind(this);
  }

  connectedCallback() {
    this.addEventListener('click', this.handleCardClick);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.handleCardClick);
  }

  async handleCardClick(event) {
    event.preventDefault();

    const target = event.target;

    if (!target || !target.dataset.href || target.classList.contains('neighboring-product__button--active')) return;

    const url = target.dataset.href;

    this.updateActiveCard(target);

    try {
      const response = await fetch(url);
      if (!response.ok) throw new Error(`Load error: ${response.status}`);

      const html = await response.text();

      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const newContent = doc.querySelector('main');

      if (newContent) {
        const currentContent = document.querySelector('main');
        currentContent.replaceWith(newContent);
        window.history.pushState({}, '', url);
        lightbox.init();

        // if (typeof ajaxCart !== 'undefined') {
        //   ajaxCart.load();
        // }

        // if (ajaxCart.init && typeof ajaxCart.init === 'function') {
        //   ajaxCart.init({
        //     formSelector: '[data-product-form]',
        //     cartContainer: '#CartContainer',
        //     addToCartSelector: 'input[type="submit"]',
        //     cartCountSelector: null,
        //     cartCostSelector: null,
        //     moneyFormat: '${{amount}}',
        //     disableAjaxCart: false,
        //     enableQtySelectors: true
        //   });
        // }

        // this.reinitializeScripts(newContent, 'data-buybox-init');
        // this.reinitializeScripts(doc, 'data-theme-js');
        // this.reinitializeScripts(doc, 'data-jdgm-script');
      }
    } catch (error) {
      console.error('Update content error:', error);
    }
  }

  updateActiveCard(activeCard) {
    const cards = this.querySelectorAll('.neighboring-product__button');
    cards.forEach(card => card.classList.remove('neighboring-product__button--active'));
    activeCard.classList.add('neighboring-product__button--active');
  }

  reinitializeScripts(doc, dataAtr) {
    const script = doc.querySelector(`script[${dataAtr}]`);
    if (script) {
      try {
        const newScript = document.createElement('script');

        Array.from(script.attributes).forEach(attr => {
          newScript.setAttribute(attr.name, attr.value);
        });

        if (script.textContent) {
          newScript.textContent = script.textContent;
        }

        document.querySelectorAll(`script[${dataAtr}]`).forEach(el => {
          el.remove();
        })

        document.body.appendChild(newScript);
      } catch (error) {
        console.error('Failed to reinitialize script:', error);
      }
    }
  }
}

customElements.define('neighboring-product', NeighboringProduct);

class ProductLabels extends HTMLElement {
  constructor() {
    super();
    this.handleLabelClick = this.handleLabelClick.bind(this);
  }

  connectedCallback() {
    this.querySelectorAll('.product__label-wrapper').forEach(label => label.addEventListener('click', this.handleLabelClick));
  }

  disconnectedCallback() {
    this.querySelectorAll('.product__label-wrapper').forEach(label => label.removeEventListener('click', this.handleLabelClick));
  }

  handleLabelClick(event) {
    const target = event.currentTarget;

    if (!target || target.classList.contains('product__label-radio-input') || target.classList.contains('is-selected')) return;

    this.updateActiveLabel(target);

    if (target.classList.contains('product__label-wrapper--sub')) {
      this.updateSellingPlan(target.dataset.sellingPlan);
    } else {
      this.updateSellingPlan('');
    }
  }

  updateActiveLabel(activeLabel) {
    const labels = this.querySelectorAll('.wt-product__main .product__label-wrapper');
    labels.forEach(label => label.classList.remove('is-selected'));
    activeLabel.classList.add('is-selected');

    if (activeLabel.classList.contains('product__label-wrapper--onetime')) {
      let otpQuantity = +this.closest('.wt-product__main').querySelector('.product__label-wrapper--onetime .counter-wrapper .js-counter-quantity').value;
      this.updateQunanity(otpQuantity);
    } else {
      let subQuantity = +this.closest('.wt-product__main').querySelector('.product__label-wrapper--sub .product__choose-plan-button--active').dataset.planQuantity;
      this.updateQunanity(subQuantity);
    }
  }

  updateSellingPlan(id) {
    this.closest('.wt-product__main').querySelector('input[name=selling_plan]').value = id;
  }

  updateQunanity(num) {
    this.closest('.wt-product__main').querySelector('.wt-product__add-to-cart_form--wrapper .js-counter-quantity').value = num;
  }
}

customElements.define('product-labels', ProductLabels);

class ChoosePlan extends HTMLElement {
  constructor() {
    super();
    this.handleButtonClick = this.handleButtonClick.bind(this);
  }

  connectedCallback() {
    this.querySelectorAll('.product__choose-plan-button').forEach(button => button.addEventListener('click', this.handleButtonClick));
  }

  disconnectedCallback() {
    this.querySelectorAll('.product__choose-plan-button').forEach(button => button.removeEventListener('click', this.handleButtonClick));
  }

  handleButtonClick(event) {
    const target = event.currentTarget;

    if (!target || target.classList.contains('product__choose-plan-button--active')) return;

    this.updateActiveButton(target);
    this.updateSellingPlan(target.dataset.planId);
    this.updateQunanity(target.dataset.planQuantity);
  }

  updateActiveButton(activeButton) {
    const labels = this.querySelectorAll('.product__choose-plan-button');
    labels.forEach(button => button.classList.remove('product__choose-plan-button--active'));
    activeButton.classList.add('product__choose-plan-button--active');
  }

  updateSellingPlan(id) {
    this.closest('.wt-product__main').querySelector('input[name=selling_plan]').value = id;
  }

  updateQunanity(num) {
    this.closest('.wt-product__main').querySelector('.wt-product__add-to-cart_form--wrapper .js-counter-quantity').value = num;
  }
}

customElements.define('choose-plan', ChoosePlan);